var $ = require('jquery');
require('magnific-popup');

/**
 * Machine downloads element in Extranet Customer Machine card
 * @class
 */
export class MachineFiles {
  private $el;
  private $editBtn;
  private $fileUploader;
  private $deleteBtns;
  private $messageModalSelector;
  private $confirmModalSelector;
  private $confirmBtn;

  constructor(private downloadsElement:HTMLElement) {
    this.$el = $(downloadsElement);

    this.$editBtn = this.$el.find('.machine-files__edit-btn');
    this.$fileUploader = this.$el.find('.machine-files__uploader');

    this.$deleteBtns = this.$el.find('.machine-files__delete-file');

    this.$messageModalSelector = '.machine-files__message-modal';
    this.$confirmModalSelector = '.machine-files__confirm-modal';
    this.$confirmBtn = $(this.$confirmModalSelector).find('.popup-modal-continue');
  }

  /**
   * Handle Edit files -button click
   */
  _onEditModeClick() {
    //toggle edit view
    if(this.$el.hasClass('machine-files--editmode')){
      this.$fileUploader.collapse('hide');
      this._hideUploadStatus();
      this.$editBtn.text(this.$editBtn.data('text-edit'));
    } else {
      this.$fileUploader.collapse('show');
      this.$editBtn.text(this.$editBtn.data('text-stop-edit'));
    }

    this.$el.toggleClass('machine-files--editmode');
  }

  /**
   * Delete defined file from database
   * @param {string} fileId uuid of the downloads file
   * @param {JQuery} fileContainer file container element
   * @param {string} fileType file type
   */
  _deleteFile(fileId, fileContainer, fileType){
    const ajaxUrl = fileType === 'certificate' ? '/stage-ajax/remove-certificate/' : '/stage-ajax/delete-machine-file/';
    let title;
    let message;

    //send ajax request to remove file
    $.ajax({
      type: 'get',
      url: ajaxUrl,
      data: {fileId : fileId},
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: (err) => {
        title = err.error ? err.error : 'Error';
        message = err.message ? err.message : '';
        this._showModalMessage(title, message);
      },
      success: (response) => {
        if(response.success) {
          title = response.success;
          fileContainer.hide();
          message = response.data && response.data.messageMarkdown ? response.data.messageMarkdown : response.message;
        } else if(response.error) {
          title = response.error;
          message = response.message ? response.message : '';
        }

        this._showModalMessage(title, message);
      }
    });
  }

  /**
   * Hides upload forms succes/failure message, if exists
   */
  _hideUploadStatus() {
    this.$fileUploader.find('.machine-files__upload-status').hide('slow');
  }

  /**
   * Shows modal with defined title and message
   * @param {string} title modal title
   * @param {string} message modal message
   */
  _showModalMessage(title, message) {
    $(this.$messageModalSelector).find('.title').text(title);
    $(this.$messageModalSelector).find('.message').html(message);

    $.magnificPopup.open({
      'items': {
        'src': this.$messageModalSelector,
        'type': 'inline',
        'midClick': true
      }
    });
  }

  /**
   * Asks user confirmation
   * @param {function} callback function to be executed on confirm
   * @param {array} params params for the callback function
   * @param {string} confirmDetails file details to include in confirmation message
   */
  _showDeleteConfirm(callback, params, confirmDetails) {

    $(this.$confirmModalSelector).find('.file-details').text(confirmDetails); // add file info to modal

    this.$confirmBtn.on('click', (e) => {
      this.$confirmBtn.off(); // removes event listeners
      callback(...params);
      $.magnificPopup.close();
    });

    $.magnificPopup.open({
      'items': {
        'src': this.$confirmModalSelector,
        'type': 'inline',
        'midClick': true
      }
    });
  }

  /**
   * Handles files delete button click
   * @param {object} e event object
   */
  _onDeleteClick(e){
    const btn = $(e.currentTarget);
    const fileContainer = btn.parents('.list__file');
    const fileId = fileContainer.data('file-id');
    const fileType = fileContainer.data('file-type');
    const fileName = fileContainer.find('.file-list__name').text();
    this._hideUploadStatus();

    //show confirmation dialog
    const deleteParams = [fileId, fileContainer, fileType];
    this._showDeleteConfirm(this._deleteFile.bind(this), deleteParams, fileName);
  }

   /**
   * Binds click events
   */
  public init() {
    this.$editBtn.on('click', this._onEditModeClick.bind(this));
    this.$deleteBtns.on('click', this._onDeleteClick.bind(this));

    this.$el.find('.popup-modal-dismiss').on('click', function(e) {
      $.magnificPopup.close();
    });
  }

}
